import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconTwitter(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.95 1.462a.667.667 0 0 1 1.032.703 5.803 5.803 0 0 1-1.33 2.516c.01.108.015.217.015.326 0 7.906-7.631 11.968-14.324 8.249-.614-.341-.351-1.277.35-1.249a7.097 7.097 0 0 0 3.25-.645c-1.469-.906-2.41-2.105-2.872-3.523-.477-1.465-.407-3.004-.009-4.465.12-.442.243-.775.329-.971a.667.667 0 0 1 1.155-.112 6.44 6.44 0 0 0 4.788 2.721 3.654 3.654 0 0 1 6.089-2.748 6.604 6.604 0 0 0 1.527-.801zm-1.516 2.203a.665.665 0 0 1-.695-.201 2.32 2.32 0 0 0-4.07 1.563v.667a.666.666 0 0 1-.649.666 7.774 7.774 0 0 1-5.748-2.324c-.263 1.137-.283 2.309.069 3.391.451 1.387 1.485 2.513 3.265 3.305a.667.667 0 0 1 .104 1.161 8.43 8.43 0 0 1-2.42 1.131c5.119 1.347 10.045-2.052 10.045-8.014 0-.144-.014-.288-.041-.43a.665.665 0 0 1 .187-.6 4.44 4.44 0 0 0 .412-.467 7.45 7.45 0 0 1-.458.153z"
  }));
}
IconTwitter.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconTwitter.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconTwitter as default };
